
import { defineComponent, ref, onMounted } from "vue";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import ApiService from "@/core/services/ApiService";
import { apiEndpoint } from "@/mixin/apiMixin";
import { ElNotification } from "element-plus";
import { useBus } from "@/bus";
import { DrawerComponent } from "@/assets/ts/components";
import GenderPolicyModal from "@/components/modals/forms/genderPolicy/GenderPolicyModal.vue";

export default defineComponent({
  name: "GenderPolicyList",
  mixins: [apiEndpoint],
  components: {
    GenderPolicyModal,
  },
  setup() {
    const { bus } = useBus();
    const editData = ref(null);
    const exportType = ref(null);
    const genderPolicyList = ref([]);
    const selectedMinistry = ref("");
    const ministryOptions = ref([]);

    const create = (data) => {
      editData.value = data ? data : null;
    };

    const edit = (data) => {
      editData.value = data;
    };

    const deleteReport = async (id) => {
      Swal.fire({
        title: "Are you sure you want to delete it?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await ApiService.post(
              apiEndpoint.data().VUE_APP_GENDER_POLICY_REPORT_DELETE,
              {
                id: id,
              }
            );

            if (response.data.status == "success") {
              ElNotification({
                dangerouslyUseHTMLString: true,
                message: response.data.data,
                type: "success",
              });
              loadData();
            } else {
              ElNotification({
                dangerouslyUseHTMLString: true,
                message: response.data.message,
                type: "error",
              });
            }
          } catch (error) {
            console.error("Error deleting report:", error);
            ElNotification({
              dangerouslyUseHTMLString: true,
              message: "Error deleting report",
              type: "error",
            });
          }
        }
      });
    };

    const loadData = async () => {
      try {
        const response = await ApiService.post(
          apiEndpoint.data().VUE_APP_GENDER_POLICY_REPORT_LIST,
          {
            ministry: selectedMinistry.value ? selectedMinistry.value : null,
          }
        );

        genderPolicyList.value = response.data.data;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    const getMinistryOptions = async () => {
      try {
        const response = await ApiService.post(
          apiEndpoint.data().VUE_APP_MINISTRY_LIST,
          {}
        );

        ministryOptions.value = response.data.data.map((option) => option.name);
      } catch (error) {
        console.error("Error fetching ministry options:", error);
      }
    };

    const exportChange = async () => {
      if (exportType.value == "excel") {
        exportExcel();
      }
    };

    const exportExcel = async () => {
      try {
        const response = await ApiService.post(
          apiEndpoint.data().VUE_APP_GENDER_POLICY_REPORT_EXPORT,
          {
            ministry: selectedMinistry.value ? selectedMinistry.value : null,
          }
        );

        if (response.data.status === "success" && response.data.url) {
          const downloadLink = document.createElement("a");
          downloadLink.href =
            apiEndpoint.data().BEE_FILE_URL + response.data.url;
          downloadLink.target = "_blank";
          downloadLink.download = "Gender_Policy_Report.xlsx";

          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
        } else {
          console.error("Invalid response for export:", response);
        }
      } catch (error) {
        console.error("Error exporting Excel:", error);
      }
    };

    onMounted(async () => {
      DrawerComponent.bootstrap();
      DrawerComponent.updateAll();

      loadData();
      getMinistryOptions();

      bus.on("loadData", async () => {
        loadData();
      });
    });

    return {
      editData,
      genderPolicyList,
      create,
      edit,
      deleteReport,
      selectedMinistry,
      ministryOptions,
      loadData,
      exportChange,
      exportType,
    };
  },
});
